const hj = window.hj;
export function identifyHotjar(userId = null, email = "") {
  try {
    hj("identify", userId, {
      email
    });
  } catch (error) {
  }
}
